export enum VehicleType {
  PATENT = 'patent',
  VIN = 'vin',
}
